import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

const LIVERY_BENEFITS = [
  {
    title: 'Wide Selection of Talented Designers',
    description:
      'Grid Finder hosts an array of skilled livery designers, offering a diverse range of styles to match your personal or team branding.',
  },
  {
    title: 'Quality and Creativity',
    description:
      'Each designer on Grid Finder is dedicated to creativity and quality, ensuring that you get a design that is unique and professionally crafted.',
  },
  {
    title: 'Easy Browsing and Selection',
    description:
      "The platform's user-friendly interface allows you to effortlessly browse and compare different designers' work, making the selection process easy.",
  },
  {
    title: 'Tailored for Various Racing Titles',
    description:
      "With designers specializing in different sim racing titles, you're guaranteed to find the perfect match for your specific game, be it iRacing, Assetto Corsa Competizione, rFactor 2 or Assetto Corsa.",
  },
]

export default function LiveryDropdowns() {
  return (
    <section
      aria-labelledby="livery-benefits-heading"
      className="mx-auto mt-[71px] w-full font-inter lg:max-w-5xl desktop-xs:mt-[100px]"
    >
      <h2
        id="livery-benefits-heading"
        className="text-h-4-sm font-semibold tablet:text-h-3-sm desktop-xs:text-h-3"
      >
        Why choose Grid Finder for your sim racing livery designs?
      </h2>

      <Accordion
        type="single"
        collapsible
        className="mt-6 overflow-hidden rounded-xl border border-neutral-blue-700 bg-neutral-blue-900/60"
      >
        {LIVERY_BENEFITS.map((benefit, index) => (
          <AccordionItem
            key={benefit.title}
            value={`benefit-${index + 1}`}
            className="px-5 last:border-b-0 tablet:px-6"
          >
            <AccordionTrigger
              className="py-5 text-left text-p-2 font-semibold text-shades-0 tablet:text-h-6"
              iconClassName="size-6 stroke-shades-0"
            >
              {benefit.title}
            </AccordionTrigger>
            <AccordionContent className="max-w-3xl pb-5 text-p-1 leading-relaxed text-neutral-blue-300 tablet:text-p-2">
              {benefit.description}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  )
}
